<template>
  <div class="vx-row">
    <div class="vx-col w-full mb-base">
      <vx-card class="mb-5">
        <vs-row vs-w="12" class="mb-5">
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="1"
            vs-sm="4"
            vs-xs="12"
          >
            <vs-button
              @click="goBack"
              color="danger"
              type="border"
              icon="keyboard_backspace"
              >Back</vs-button
            >
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="10"
            vs-sm="4"
            vs-xs="12"
          >
            <h3>View Master Fields</h3>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="1"
            vs-sm="4"
            vs-xs="12"
          >
            <!-- <vs-button
              @click="editMasterField"
              icon="edit"
              color="danger"
              type="border"
              >Edit</vs-button
            > -->
          </vs-col>
        </vs-row>
        <vs-divider class="m-5" />

        <div class="vx-row p-5" v-if="masterFieldDescription.name">
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              Name:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ masterFieldDescription.name }}
          </div>
        </div>
        <div class="vx-row p-5" v-if="masterFieldDescription.description">
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              Description:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ masterFieldDescription.description }}
          </div>
        </div>
        <div class="vx-row p-5" v-if="masterFieldDescription.level">
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              Level:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ masterFieldDescription.level }}
          </div>
        </div>
        <div class="vx-row p-5">
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              Sales Developer Access:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ masterFieldDescription.sales_developer_access }}
          </div>
        </div>
        <div class="vx-row p-5" v-if="masterFieldDescription.type">
          <div class="vx-col sm:w-1/5 w-full">
            <span>
             Type:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ masterFieldDescription.type }}
          </div>
        </div>
        <!-- <div class="vx-row p-5" v-if="masterFieldDescription.values">
          <div class="vx-col sm:w-1/5 w-full">
            <span>
             Value:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ JSON.parse(masterFieldDescription.values) }}
          </div>
        </div> -->
        <div class="vx-row p-5" v-if="masterFieldDescription.type">
          <div class="vx-col sm:w-1/5 w-full">
             
          </div>
          <span><b>
              Example :
           </b> </span>
          <div
            class="vx-col sm:w-1/3 w-full"
            v-if="masterFieldDescription.type == 'text'"
          >
            <vs-input class="w-full" name="name" />
          </div>
          <div
            class="vx-col sm:w-1/3 w-full"
            v-if="masterFieldDescription.type == 'number'"
          >
            <vs-input class="w-full" name="name" type="number" />
          </div>
          <div
            class="vx-col sm:w-1/3 w-full"
            v-if="masterFieldDescription.type == 'textarea'"
          >
            <vs-textarea v-model="textarea" />
          </div>
          <div
            class="vx-col sm:w-1/3 w-full"
            v-if="masterFieldDescription.type == 'date'"
          >
             <flat-pickr
                      :config="configDateTimePicker"
                      placeholder="Choose Date"
                      name="continuous_date_end"
                    />
          </div>

           <div
            class="vx-col sm:w-1/3 w-full"
            v-if="masterFieldDescription.type == 'datetime'"
          >
             <flat-pickr
                      :config="configDateAndTimePicker"
                      placeholder="Choose Date and Time"
                      name="continuous_date_and_time_end"
                    />
          </div>

          <div
            class="vx-col sm:w-1/3 w-full"
            v-if="masterFieldDescription.type == 'checkbox'"
          >
            <span
              v-for="v in JSON.parse(masterFieldDescription.values)"
              class="p-2"
            >
              <vs-checkbox class="mr-2">{{ v.value }}</vs-checkbox>
            </span>
          </div>

          <div
            class="vx-col sm:w-1/3 w-full"
            v-if="masterFieldDescription.type == 'dropdown'"
          >
            <v-select
              label="value"
              :options="JSON.parse(masterFieldDescription.values)"
              name="type"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
            />
          </div>

          <div
            class="vx-col sm:w-1/3 w-full"
            v-if="masterFieldDescription.type == 'choose_one'"
          >
          <!-- {{masterFieldDescription.values}} -->
            <span
              v-for="v in JSON.parse(masterFieldDescription.values)"
              class="p-2"
            >
              <vs-radio vs-name="radios1" vs-value="luis" class="mr-2">{{
                v.value
              }}</vs-radio>
            </span>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>
<script>
// Store Module
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import defineAbilitiesFor from "@/config/abilities";
import _ from "lodash";
import moduleMasterFieldsManagement from "@/store/fields-management/master-fields-management/moduleMasterFieldsManagement.js";
import vSelect from "vue-select";
export default {
  data() {
    return {
      configDateTimePicker: {
        enableTime: false,
        dateFormat: "Y-m-d",
      },
      configDateAndTimePicker: {
      enableTime: true,
      dateFormat: "Y-m-d H:i:s",
      enableSeconds : true
    },
      abilities: null,
      masterFieldDescription: [],
      fieldId: null
    };
  },
  components: {
    "v-select": vSelect,
    moduleMasterFieldsManagement,
        flatPickr

  },
  created() {
    var self = this;
    defineAbilitiesFor().then(function(data) {
      self.abilities = data;
    });
    if (!moduleMasterFieldsManagement.isRegistered) {
      this.$store.registerModule(
        "MasterFieldsManagement",
        moduleMasterFieldsManagement
      );
      moduleMasterFieldsManagement.isRegistered = true;
    }
  },
  mounted() {
    this.fieldId = this.$route.params.fieldId;
    this.fetchMasterField();
  },
  methods: {
    goBack: function() {
      this.$router.go(-1);
    },
    fetchMasterField() {
      this.$store
        .dispatch("MasterFieldsManagement/fetchFields", this.fieldId)
        .then(res => {
          let result = JSON.parse(res.data);
          this.masterFieldDescription = result[0]
          // console.log(this.masterFieldDescription[0])
        })
        .catch(err => {
          console.error(err);
        });
    },
    editMasterField() {
      this.$router.push({ path: `/fields/master-field/edit/${this.fieldId}` });
    }
  }
};
</script>
<style scoped>
.con-vs-popup .vs-popup {
  width: 900px !important;
}

.item.expanded {
  color: black !important;
  background-color: none !important;
}

.vs-icon-bg.bg-small {
  width: 2.5rem;
  height: 2.5rem;
  border: 1px solid red;
  margin: 0px 20px;
  cursor: pointer;
}

.inputx {
  width: 50px;
}
.vs-table--tbody-table tr {
  -webkit-transition: none;
  transition: none;
  background: #fff;
}

.vs-table--tbody-table
  .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  -webkit-transform: none;
  transform: none;
}
.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  padding: 25px 15px;
  font-weight: 600;
  font-size: 14px;
}
/* 
.item.expanded{
    background-color:white !important;
    color:black !important;
    cursor: pointer !important;
} */
</style>
